import React from "react";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

const CButton = ({
  cId,
  cText,
  cSrc,
  cTooltipText,
  cDisabled,
  cOnClick,
  cLink,
  cFullWidth,
   cColor='primary'
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (cOnClick !== undefined) {
      cOnClick();
    }
  };

  return (
    <Tooltip title={t(cTooltipText)} arrow>
      <span>
        {(cText !== undefined && (
          <Button
            id={cId}
            aria-label={cTooltipText}
            disabled={cDisabled}
            onClick={handleClick}
             color={cColor ? cColor : 'primary'}
            variant="contained"
            fullWidth={cFullWidth}
          >
            {cText}
          </Button>
        )) ||
          (cSrc !== undefined && (
            <IconButton
              id={cId}
              aria-label={cTooltipText}
              disabled={cDisabled}
              onClick={handleClick}
              color="primary"
              variant="contained"
            >
              {cSrc}
            </IconButton>
          ))}
      </span>
    </Tooltip>
  );
};

export default CButton;
